export default __webpack_public_path__ + "static/media/trade-in-req2.959b570c.png";